
import { RelatedServicesSection } from "@/components/services/RelatedServicesSection";
import { wisdomToothData } from "./wisdomToothData";

export const WisdomToothRelated = () => {
  const handleBookAppointment = () => {
    window.open("https://www.healthcoco.com/nagpur/doctor/dr-hemant-asrani-endodontist-dentist/USRH249D644", "_blank");
  };

  return (
    <RelatedServicesSection
      title="Experiencing Wisdom Tooth Pain?"
      description="Contact Asrani Dental in Sadar, Nagpur today to schedule your wisdom tooth consultation. Our expert team is ready to provide relief and prevent future complications."
      primaryButtonText="Book Appointment"
      secondaryButtonText="Contact Us"
      primaryButtonAction={handleBookAppointment}
      secondaryButtonAction={() => window.location.href = '/contact'}
      relatedServices={wisdomToothData.relatedServices}
    />
  );
};
